import React from "react";
import { Box, Tooltip } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

export const RowDragHandle = ({
  rowId,
  isSelected,
  selectedCount,
  onReorderDragStart,
}) => {
  const tooltipText =
    isSelected && selectedCount > 1
      ? `Arrastrar ${selectedCount} notas seleccionadas para reordenar en la tabla`
      : "Arrastrar para reordenar en la tabla";

  return (
    <Tooltip title={tooltipText} placement="top" arrow>
      <Box
        component="div"
        draggable
        onDragStart={(e) => {
          e.stopPropagation(); 
          onReorderDragStart(e, rowId);
        }}
        onClick={(e) => e.stopPropagation()} 
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "grab",
          color: isSelected ? "#1976d2" : "#9e9e9e",
          p: 0.25,
          borderRadius: "4px",
          transition: "all 0.15s ease",
          "&:hover": {
            color: "#1976d2",
            backgroundColor: "rgba(25, 118, 210, 0.08)",
          },
          "&:active": {
            cursor: "grabbing",
          },
        }}
      >
        <DragIndicatorIcon sx={{ fontSize: 18 }} />
      </Box>
    </Tooltip>
  );
};
